import { gql } from './gql-func';

export const agentSummaryFields = gql`
fragment agentSummaryFields on AgentInfo {
  id
  name
  org_id
  org_name
  mode
  lang
  is_interface
  is_service
  is_service_implementation
  permission
  struct_key {
    ...originKeyFields
  }
  deploy_mode
  region
  pr_approval_required
  privacy
  time_zone
}
`;
export const dhlKeyFields = gql`
fragment dhlKeyFields on DHLKey {
  agent_id
  meta_id
  owner_id
  frame_id
}
`;


export const originKeyFields = gql`
fragment originKeyFields on OriginKey {
  agent_id
  user_id
  commit_number
}
`;

export const variableFields = gql`
fragment variableFields on ReferenceNode {
  id
  name
  type
  show_index
  index
}
`;

export const augmentFields = gql`
fragment augmentFields on AugmentMeta {
  prompt
  model_id
  inference_config {
    temperature
    topk
    max_input_length
    max_think_length
    max_output_length
  }
  context_collections {
    remote
    source
    file_type
    knowledge_label
    related_tags {
      key
      value
    }
  }
  contexts
  examples
  example_collections {
    source
    related_tags {
      key
      value
    }
  }
}
`;


export const serviceSlotFields = gql`
fragment serviceSlotFields on ServiceSlot {
  id
  label
  type {
    id
    name
    type
  }
  integration_label
  state
}
`;

export const intentSummaryFields = gql`
fragment intentSummaryFields on IntentInfo {
  id
  name
  comment
  struct_key {
    ...originKeyFields
  }
  origin_key {
    ...originKeyFields
  }
  agent_id
  source
  local_plus
  qualification
  external_qualification
  dialog_act
}
`;

export const compositeSummaryFields = gql`
fragment compositeSummaryFields on CompositeInfo {
  id
  name
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  agent_id
  synonym
  source
  qualification
  is_interface
  cui_disabled
  local_plus
}
`;

export const serviceSummaryFields = gql`
fragment serviceSummaryFields on ServiceInfo {
  id
  name
  comment
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  agent_id
  source
  qualification
  is_interface
  is_impelementation
  local_plus
}
`;

export const trainingPhraseFields = gql`
fragment trainingPhraseFields on TrainingPhraseInfo {
  id
  frame_id
  agent_id
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  owner_id
  owner_type
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
  phrase_type
  training_phrase
  label
  master_self {
    training_phrase
  }
}
`;

export const overwroteTrainingPhrase = gql`
fragment overwroteTrainingPhrase on OverwroteTrainingPhrase {
  training_phrase
  label
}
`;

export const attributeSummaryFields = gql`
fragment attributeSummaryFields on AttributeInfo {
  id
  name
  comment
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  agent_id
  owner_id
  owner_type
  type {
    id
    name
    type
  }
  triggers
  description
  multi_value
  allow_dont_care
  allow_prompt
  allow_confirm
  allow_expression
  allow_slot_update
  enable_value_expression
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
}
`;

export const attributeFields = gql`
fragment attributeFields on AttributeInfo {
  id
  name
  comment
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  agent_id
  owner_id
  owner_type
  type {
    id
    name
    type
  }
  customization_path {
    id
    name
    type
  }
  implementation {
    id
    name
    type
  }
  triggers
  description
  confirmations {
    ...confirmationFields
  }
  multi_valued_confirmations {
    ...confirmationFields
  }
  multi_value
  multi_value_min
  multi_value_max
  allow_multi_value_prompt
  allow_dont_care
  allow_prompt
  allow_confirm
  allow_multi_valued_confirm
  allow_expression
  allow_value_suggestion
  allow_value_check
  allow_initialization
  enable_filtering
  allow_dialog_act
  allow_post_fill_action
  allow_slot_update
  allow_companion
  enable_value_expression
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
  prompt_questions {
    ...promptFields
  }
  prompt_expressions {
    ...trainingPhraseFields
  }
  value_expressions {
    ...trainingPhraseFields
  }
  multi_value_questions {
    ...promptFields
  }
  multi_value_expressions_no {
    ...trainingPhraseFields
  }
  multi_value_min_exceptions {
    ...promptFields
  }
  multi_value_max_exceptions {
    ...promptFields
  }
  dont_care_expressions {
    ...trainingPhraseFields
  }
  boolean_gated
  gated_type {
    id
    name
    type
  }
  boolean_gate_prompts
  boolean_gate_expressions_yes {
    ...trainingPhraseFields
  }
  boolean_gate_expressions_no {
    ...trainingPhraseFields
  }
  slot_update_expressions {
    ...trainingPhraseFields
  }
  slot_append_expressions {
    ...trainingPhraseFields
  }
  slot_delete_expressions {
    ...trainingPhraseFields
  }
  negative_expressions {
    ...trainingPhraseFields
  }
  entailment_expressions {
    ...trainingPhraseFields
  }
  abort_expressions {
    ...trainingPhraseFields
  }
  abort_negative_expressions {
    ...trainingPhraseFields
  }
  abort_entailment_expressions {
    ...trainingPhraseFields
  }
  attribute_companions {
    owner_id
    owner_type
    frame_id
    inherited_from_composite_id
    inherited_from_composite_name
    is_overwrite
    origin_key {
      ...originKeyFields
    }
    id
    name
    multi_value
    expressions {
      ...trainingPhraseFields
    }
  }
  fill_mode
  messaging_type
  fill_with_natural_language
  ask_strategy
  ask_condition_type
  ask_conditions {
    variable {
      id
      name
      type
      show_index
      index
    }
    parameters {
      type
      variable {
        ...variableFields
      }
      constant
    }
    conditions {
      operation_at
      operation
      value
    }
  }
  ask_code_condition
  condition_comment
  inform_prompts {
    ...promptFields
  }
  initializations {
    id
    owner_id
    owner_type
    frame_id
    inherited_from_composite_id
    inherited_from_composite_name
    is_overwrite
    target {
      ...variableFields
    }
    association
    association_comment
  }
  filterings {
    id
    owner_id
    owner_type
    frame_id
    inherited_from_composite_id
    inherited_from_composite_name
    is_overwrite
    source_slot {
      ...variableFields
    }
    filtering_expression
    inform_prompts {
      ...promptFields
    }
  }
  auxiliary
  value_suggestions {
    ...valueSuggestionFields
  }
  value_checks {
    ...valueCheckFields
  }
  dialog_acts {
    ...dialogActFields
  }
  post_fill_actions {
    ...postFillActionFields
  }
  storage_annotation {
    id
    origin_key {
      ...originKeyFields
    }
    struct_key {
      ...originKeyFields
    }
    owner_id
    data_type
    for_url
    not_null
    default_value
    input_type
    dropdown
    hide_in_list_view
    read_only
    sortable
    relationship
  }
}
`;

export const intentFields = gql`
fragment intentFields on IntentInfo {
  id
  name
  comment
  source
  qualification
  external_qualification
  dialog_act
  triggers
  attributes {
    ...attributeSummaryFields
  }
}
`;

export const compositeFields = gql`
fragment compositeFields on CompositeInfo {
  id
  name
  triggers
  comment
  is_global
  source
  qualification
  external_qualification
  source_type
  inherited_frames {
    frame {
      id
      type
      name
    }
  }
  is_interface
  cui_disabled
  storage_enable
  attributes {
    ...attributeSummaryFields
  }
}
`;

export const serviceFields = gql`
fragment serviceFields on ServiceInfo {
  id
  name
  comment
  source
  qualification
  external_qualification
  attributes {
    ...attributeSummaryFields
  }
}
`;

export const entityFields = gql`
fragment entityFields on EntityInfo {
  id
  name
  synonym
  comment
  is_global
  type
  source
  external_qualification
  source_type
  qualification
  cui_disabled
  recognizer
  content {
    label
    id
  }
  normalizable
}
`;

export const dataQuerySummaryFields = gql`
fragment dataQuerySummaryFields on DataQueryInfo {
  id
  name
  comment
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  owner_id
  owner_type
  query_type
  schedule
  kotlin
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
  multi_value
  error_messages
  parameters {
    name
    type {
      id
      name
      type
    }
    multi_value
    nullable
    comment
  }
  type {
    id
    type
    name
  }
  function_config {
    is_static
  }
  allow_trigger
}
`;

export const dataQueryFields = gql`
fragment dataQueryFields on DataQueryInfo {
  id
  name
  comment
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  readonly
  owner_id
  owner_type
  parameters {
    name
    type {
      id
      name
      type
    }
    multi_value
    nullable
    comment
  }
  query_type
  schedule
  kotlin
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
  multi_value
  disable_return_null
  database_config {
    function_meta {
      key
      value
    }
    query
    result_format
    cron
  }
  restful_config {
    method
    url
    path
    post_body
    headers {
      key
      value
    }
  }
  function_config {
    is_static
    parameters {
      name
      type {
        id
        name
        type
      }
      multi_value
    }
    body
  }
  prompt_implemented
  prompt_config {
    prompt
    model_id
    inference_config {
      temperature
      topk
      max_input_length
      max_think_length
      max_output_length
    }
    context_collections {
      remote
      source
      file_type
      knowledge_label
      related_tags {
        key
        value
      }
    }
    contexts
    examples
    example_collections {
      source
      related_tags {
        key
        value
      }
    }
  }
  body_comment
  error_messages
  type {
    id
    type
    name
  }
  allow_trigger
  trigger_expressions {
    ...trainingPhraseFields
  }
}
`;

export const valueSuggestionFields = gql`
fragment valueSuggestionFields on ValueSuggestion {
  id
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  owner_id
  owner_type
  frame_id
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
  vr_source_type
  source_type
  variable {
    ...variableFields
  }
  parameters {
    type
    variable {
      ...variableFields
    }
    constant
  }
  source
  source_comment
  source_intent {
    intent {
      id
      name
      type
    }
    assignments {
      slot {
        id
        name
        type
      }
      code_expression
      code_comment
    }
  }
  channels {
    tag
    actions {
      id
      type
      list_action {
        source
        source_comment
        header
        footer
        body
        template_id
        item_size
        delimiter_field
        delimiter_end
        single_prompts
        zero_prompts
      }
    }
  }
  soft
  prompts {
    ...promptFields
  }
  zero_prompts {
    ...promptFields
  }
  single_affirmatives {
    ...trainingPhraseFields
  }
  single_negatives {
    ...trainingPhraseFields
  }
}
`;

export const genericTypeFields = gql`
fragment genericTypeFields on GenericType {
  id
  name
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
}
`;

export const externalTypeFields = gql`
fragment externalTypeFields on ExternalType {
  id
  name
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
}
`;

export const attributeAssociationFields = gql`
fragment attributeAssociationFields on Association {
  id
  variable {
    ...variableFields
  }
  variable_type
  default_values {
    ...variableFields
  }
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
}
`;

export const stateUpdateFields = gql`
fragment stateUpdateFields on StateUpdateInfo {
  id
  name
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  owner_id
  owner_type
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite

  trigger_method
  event {
    ...variableFields
  }
  event_states {
    target_slot {
      ...variableFields
    }
    code_expression
  }
  condition_type
  conditions {
    ...triggerConditionFields
  }
  condition_code
  code_comment
  state_config {
    slot {
      ...variableFields
    }
    state
  }
  trigger_timing {
    ...variableFields
  }
  channels {
    ...channelDataFields
  }
}
`;

export const frameMappingFields = gql`
fragment frameMappingFields on FrameMapping {
  id
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  owner_id
  owner_type
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
  target_frame {
    ...variableFields
  }
  contents {
    target_slot {
      ...variableFields
    }
    mapping_slot {
      ...variableFields
    }
    conversion_mode
  }
}
`;

export const entitySummaryFields = gql`
fragment entitySummaryFields on EntityInfo {
  id
  name
  comment
  type
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  agent_id
  source
  qualification
  cui_disabled
  local_plus
  abstract
  normalizable
}
`;

export const actionFields = gql`
fragment actionFields on Action {
  id
  type
  item_action{
    template_id
    content
    other_channel_data {
      channel
      content
    }
  }
  list_action {
    header
    footer
    body
    template_id
    item_size
    source_type
    source
    source_comment
    variable {
      ...variableFields
    }
    parameters {
      type
      variable {
        ...variableFields
      }
      constant
    }
    delimiter_field
    delimiter_end
    single_prompts
    zero_prompts
    other_channel_data {
      channel
      header
      body
      footer
    }
  }
  media_action {
    url
    description
  }
  intent_start_action {
    intent {
      id
      name
      type
    }
    assignments {
      slot {
        id
        name
        type
      }
      code_expression
      code_comment
    }
    gated
  }
  external_action {
    name
    parameter_type
    parameters
  }
  intent_abort_action {
    intent {
      id
      name
      type
    }
  }
  intent_end_action {
    soft
  }
  hand_off_action {
    department {
      id
      name
      type
    }
  }
  clear_slot_action {
    slot {
      id
      name
      type
    }
  }
  fill_slot_action {
    slot {
      id
      name
      type
    }
    code_expression
    code_comment
  }
  recheck_action {
    slot {
      id
      name
      type
    }
  }
  augment_meta {
    prompt
    model_id
    inference_config {
      temperature
      topk
      max_input_length
      max_think_length
      max_output_length
    }
    context_collections {
      remote
      source
      file_type
      knowledge_label
      related_tags {
        key
        value
      }
    }
    contexts
    examples
    example_collections {
      source
      related_tags {
        key
        value
      }
    }
    structured_output
    target_frame
    target_slot
  }
}
`;

export const channelDataFields = gql`
fragment channelDataFields on Channel {
  tag
  actions {
    id
    type
    item_action{
      template_id
      content
      other_channel_data {
        channel
        content
      }
    }
    list_action {
      header
      footer
      body
      template_id
      item_size
      source_type
      source
      source_comment
      variable {
        ...variableFields
      }
      parameters {
        type
        variable {
          ...variableFields
        }
        constant
      }
      delimiter_field
      delimiter_end
      single_prompts
      zero_prompts
      other_channel_data {
        channel
        header
        body
        footer
      }
    }
    media_action {
      url
      description
    }
    intent_start_action {
      gated
      intent {
        id
        name
        type
      }
      assignments {
        slot {
          id
          name
          type
        }
        code_expression
        code_comment
      }
    }
    external_action {
      name
      parameter_type
      parameters
    }
    intent_abort_action {
      intent {
        id
        name
        type
      }
    }
    intent_end_action {
      soft
    }
    hand_off_action {
      department {
        id
        name
        type
      }
    }
    clear_slot_action {
      slot {
        id
        name
        type
      }
    }
    fill_slot_action {
      slot {
        id
        name
        type
      }
      code_expression
      code_comment
    }
    recheck_action {
      slot {
        id
        name
        type
      }
    }
    augment_meta {
      prompt
      model_id
      inference_config {
        temperature
        topk
        max_input_length
        max_think_length
        max_output_length
      }
      context_collections {
        remote
        source
        file_type
        knowledge_label
        related_tags {
          key
          value
        }
      }
      contexts
      examples
      example_collections {
        source
        related_tags {
          key
          value
        }
      }
      structured_output
      target_frame
      target_slot
    }
  }
}
`;

export const triggerConditionFields = gql`
fragment triggerConditionFields on TriggerCondition {
  variable {
    ...variableFields
    show_index
    index
  }
  parameters {
    type
    variable {
      ...variableFields
    }
    constant
  }
  conditions {
    id
    operation_at
    operation
    value
  }
}
`;

export const confirmationFields = gql`
fragment confirmationFields on ConfirmationInfo {
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  id
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
  agent_id
  owner_id
  owner_type
  frame_id
  multi_valued
  condition_type
  trigger_conditions {
    ...triggerConditionFields
  }
  code_condition
  code_comment
  explicit_confirmation
  message_type
  prompts {
    ...promptFields
  }
  list_action {
    source
    source_comment
    header
    footer
    body
    template_id
    item_size
    delimiter_field
    delimiter_end
    single_prompts
    zero_prompts
  }
  affirmatives {
    ...trainingPhraseFields
  }
  negatives {
    ...trainingPhraseFields
  }
  state
}
`;

export const promptFields = gql`
fragment promptFields on PromptQuestion {
  id
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  agent_id
  frame_id
  owner_id
  owner_type
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
  prompt
  prompt_type
  master_self {
    prompt
  }
}
`;

export const valueCheckFields = gql`
fragment valueCheckFields on ValueCheck {
  id
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  owner_id
  owner_type
  frame_id
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
  source_type
  source
  source_comment
  variable {
    id
    name
    type
  }
  parameters {
    type
    variable {
      ...variableFields
    }
    constant
  }
  prompts {
    ...promptFields
    state
  }
  recovering
  recovering_actions {
    id
    type
    clear_slot_action {
      slot {
        id
        name
        type
      }
    }
    recheck_action {
      slot {
        id
        name
        type
      }
    }
  }
}
`;

export const dialogActFields = gql`
fragment dialogActFields on DialogAct {
  id
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  owner_id
  owner_type
  frame_id
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
  intent {
    id
    name
    type
  }
  prompts {
    ...promptFields
    state
  }
}
`;

export const postFillActionFields = gql`
fragment postFillActionFields on PostFillAction {
  id
  origin_key {
    ...originKeyFields
  }
  struct_key {
    ...originKeyFields
  }
  owner_id
  owner_type
  frame_id
  inherited_from_composite_id
  inherited_from_composite_name
  is_overwrite
  condition
  condition_comment
  actions {
    ...actionFields
  }
}
`;

export const testCaseFields = gql`
fragment testCaseFields on TestCase {
  id
  name
  turns {
    query
    structure_input
    reply
    state
  }
}
`;
